import React from 'react';
import SalesSettings from '@/components/MenuDrawer/MyMenuDrawer/SubMenu/Settings/SalesSettings';
import AppVersionInfo from '@/components/MenuDrawer/MyMenuDrawer/SubMenu/Settings/AppVersionInfo';
import DeveloperMode from '@/components/MenuDrawer/MyMenuDrawer/SubMenu/Settings/DeveloperMode';
import { useAtomValue } from 'jotai';
import { appSettingState, MyInfoState } from '@/recoil/atom';

import {
  Accordion,
  AccordionBody,
  AccordionHeader,
} from '@/components/MenuDrawer/MyMenuDrawer/SubMenu/Vacation/styles';

const Settings = () => {
  const { departmentCode } = useAtomValue(MyInfoState);
  const { server } = useAtomValue(appSettingState);

  const developerMode = departmentCode === 'D180' || departmentCode === '20013';

  return (
    <div>
      <Accordion sx={{ borderBottom: '8px solid var(--dk-line, #F9FAFB) !important' }}>
        <AccordionHeader sx={{ borderBottom: 'none !important' }}>
          Sales 설정
        </AccordionHeader>
        <AccordionBody sx={{ borderTop: '1px solid var(--dk-line, #E7E9EC)' }}>
          <SalesSettings />
        </AccordionBody>
      </Accordion>
      <Accordion sx={{ borderBottom: '8px solid var(--dk-line, #F9FAFB) !important' }}>
        <AccordionHeader sx={{ borderBottom: 'none !important' }}>
          앱 버전 정보
        </AccordionHeader>
        <AccordionBody sx={{ borderTop: '1px solid var(--dk-line, #E7E9EC)' }}>
          <AppVersionInfo />
        </AccordionBody>
      </Accordion>
      {developerMode && (
        <Accordion sx={{ borderBottom: '8px solid var(--dk-line, #F9FAFB) !important' }}>
          <AccordionHeader sx={{ borderBottom: 'none !important' }}>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                width: '100%',
              }}
            >
              <div>개발모드 전환</div>
              <div
                style={{
                  display: 'inline-block',
                  padding: '4px 12px',
                  borderRadius: '999px',
                  backgroundColor: 'rgba(0, 102, 204, 0.12)',
                  fontSize: '12px',
                  color: 'var(--dk-accent, #0066CC)',
                  marginLeft: 'auto',
                }}
              >
                {server.toUpperCase()}
              </div>
            </div>
          </AccordionHeader>
          <AccordionBody sx={{ borderTop: '1px solid var(--dk-line, #E7E9EC)' }}>
            <DeveloperMode />
          </AccordionBody>
        </Accordion>
      )}
    </div>
  );
};
export default Settings;
